/**
 * 时时彩，通用模板，1分彩，2分彩，5分彩等
 */
import { connect } from 'react-redux'

import TimeBox from './TimeBox.jsx'
import Loader from '../../../components/icon/Loader.jsx'
import ReactDOM from 'react-dom'

import { DOMAIN } from '../../../constants/config';
import { DISABLE_TRACK_IMAGE } from '../../../constants/lotterys/config'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class SscHeader extends React.Component {

  constructor(props) {
    super(props);
    this.changeBalanceDisplay = this.changeBalanceDisplay.bind(this);
    this.state = {
      showBalance: true
    }
    this.numSj = this.numSj.bind(this)
    this.openDropdown = this.openDropdown.bind(this)
    this.closeDropdown = this.closeDropdown.bind(this)
    this.showBall = this.showBall.bind(this)
    this.requestNewIssue = this.requestNewIssue.bind(this);
    this.simulatedNumber = this.simulatedNumber.bind(this);
    this.handleToggleSound = this.handleToggleSound.bind(this);
    this.handleWinnerNotice = this.handleWinnerNotice.bind(this);
    this.codeList = ""
    this.million = ""
    this.lastCode = ""
    this.thousands = ""
    this.hundreds = ""
    this.ten = ""
    this.bit = ""
    this.DO_NOT_REFRESH_AUTO = ['jssm', 'pk10','ydl10'];
  }

  componentDidMount(){
    this.polling = {
      times: 0,
      timer: null
    }
    // 推送断掉的情况下，轮询历史开奖号码
    this.polling.timer = window.setInterval(function(){
      if (window.push_useble) {return}
      const __window = this.props.__METHOD.toJS().windows[this.props.windowId];
      const __user = this.props.__USER.toJS();
      if (__window.error) {return}
      this.polling.timer ++;
      // 30秒的彩种
      if (__window.current_issue.interval == 30) {
        this.props.$$LOTTERY.getHistoryIssues(__window.id, this.props.windowId, 25);
      }
      // 其他彩种
      if (__window.current_issue.interval > 30 && this.polling.timer % 2 == 0) {
        this.props.$$LOTTERY.getHistoryIssues(__window.id, this.props.windowId, 25);
      }
      // 变更投注状态
      if (this.polling.timer % 2 == 0) {
        const updateBetState = _.filter(__user.recentBet, (item) => _.includes(['未开奖', '可撤单'], item.status_desc));
        if (updateBetState) {
          this.props.$$USER.getUserBetRecent();
        }
      }
      // 时间矫正
      if (this.polling.timer % 8 == 0) {
        this.props.$$LOTTERY.getLotterySaleInfo();
      }

    }.bind(this), 15000)
  }

  // 切换是否播放声音
  handleToggleSound(){
    const __base = this.props.__BASE.toJS();
    if (__base.config.soundNotice) {
      return this.props.$$BASE.stopSoundNotice();
    }
    this.props.$$BASE.startSoundNotice();
  }

  // 切换中奖通知
  handleWinnerNotice() {
    const __base = this.props.__BASE.toJS();
    const { startWinnerNotice, stopWinnerNotice } = this.props.$$BASE;
    __base.config.winnerNotice ? stopWinnerNotice() : startWinnerNotice()
  }

  componentWillUnmount(){
    if (this.closeTimer) {window.clearTimeout(this.closeTimer)}
    if (this.delayRender) {window.clearTimeout(this.delayRender); this.stopRefreash = false;}
    window.clearInterval(this.polling.timer);
    this.polling.timer = null;
  }

  componentWillReceiveProps(nextProps){
    const __methods = nextProps.__METHOD.toJS();
    const __thisMethods = this.props.__METHOD.toJS();
    const __window = this.props.__METHOD.toJS().windows[this.props.windowId];
    const lotteryWindow = __methods.windows[nextProps.windowId];
    if (this.stopRefreash) {return;}
    if (!lotteryWindow || !lotteryWindow.current_issue) {return};
    if (__window.flag == lotteryWindow.flag && 
        _.includes(this.DO_NOT_REFRESH_AUTO, __window.flag) && __window.current_issue.history && 
        __window.current_issue.history.issue != lotteryWindow.current_issue.history.issue ) {
        this.stopRefreash = true;
        // 3秒后再渲染
        this.delayRender = window.setTimeout(function(){
          this.stopRefreash = false;
          this.props.$$BASE.randomMaker();
        }.bind(this), 3000)
        return;
    }
    // 清空
    this.historyIssue = '00000000-000';
    this.historyCode = [];
    //倒计时
    this.countdown = lotteryWindow.current_issue.countdown
    this.interval = lotteryWindow.current_issue.interval
    //当前销售期
    if (lotteryWindow.current_issue.current) {
      this.currentIssue =  lotteryWindow.current_issue.current.issue
    }else{
      this.currentIssue = null;
    }
    // 当前是否不在开售
    this.error =  lotteryWindow.error ? true : false;
    // 历史号码
    let historyCode = [];
    if (lotteryWindow.current_issue.history && !_.isEmpty(lotteryWindow.current_issue.history) && lotteryWindow.history_issue.length > 0) {
      // 新开奖之后已打开的号码走势刷新一次
      if (__window.current_issue.history && lotteryWindow.current_issue.history && lotteryWindow.current_issue.history.issue != __window.current_issue.history.issue) {
        const __base = this.props.__BASE.toJS();
        if (__base.dragFrame.display) {
          window.setTimeout(() => document.getElementById('dragMask').contentWindow.location.reload(true), 5000)
        }
      }
      // 香港六合擦
      if(nextProps.params.lotteryFlag == "xglhc"){
        let newArry = lotteryWindow.current_issue.history.code.split("")
        let str1 = lotteryWindow.current_issue.history.code.slice(0,12)
        let str2 = lotteryWindow.current_issue.history.code.slice(12)
        let str3 = "--"
        //在中奖号码中插入--
        newArry = str1.concat(str3,str2)
        historyCode = _.chunk(newArry,2).map((item)=>{
            return _.join(item,'')
        })
      }
      // 秒秒彩
      if (nextProps.params.lotteryFlag == "mmc") {
        if (lotteryWindow.history_issue.length > 0) {
          historyCode = lotteryWindow.history_issue[0].split_code;
        }else{
          historyCode = ['-','-','-','-','-']
        }
      }
	    if (lotteryWindow.history_issue.length > 0){
		    // 其他通用彩种
		    historyCode = historyCode.length > 2 ? historyCode : 
          ( lotteryWindow.history_issue[0].split_code.length > 2 ? lotteryWindow.history_issue[0].split_code : ['-','-','-','-','-'] )
		    this.historyIssue = lotteryWindow.current_issue.history.issue;
	    }else {
		    historyCode = ['-','-','-','-','-']
	    }
    }
    this.historyCode = historyCode.map((item,index)=>{
      switch(nextProps.params.lotteryFlag){
        case "pk10":
        case "ynpk10ff":
        case "ynpk10wf":
        case "jssc":{
          if(historyCode.length<10){
            return false
          }
          return <li className = {"car"+item +" carBox"+index} key = {index}><span className = "issueBox">{item}</span></li>;
        }
        case "ydl10":{
          if(historyCode.length<10){
            return false
          }
          return <li className = {"car"+item +" carBox"+index} key = {index}><span className = "issueBox">{item}</span></li>;
        }
        case "xyft":{
          if(historyCode.length<10){
            return false
          }
          return <li className = {"car"+item +" carBox"+index} key = {index}><span className = "issueBox">{item}</span></li>;
        }
        break;
        case "jssm":{
          if(historyCode.length<10){
            return false
          }
          return <li className = {"horse"+item +" horseBox"+index} key = {index}><span className = "issueBox">{item}</span></li>;
        }
        break;
        case "xglhc":{
          let colorClass = "green"
          if(_.includes(["01","02","07","08","12","13","18","19","23","24","29","30","34","35","40","45","46"],item)){
            colorClass = "red"
          }
          if(_.includes(["03","04","09","10","14","15","20","25","26","31","36","37","41","42","47","48"],item)){
            colorClass = "blue"
          }
          if(_.includes(["--"],item)){
            colorClass = "and"
          }
          return <li className = {colorClass + " issueBox"+index} key = {index}><span className = "issueBox">{item}</span></li>;
        }
        break;
        case "mmc":{
          if (lotteryWindow.simulating) {
            return <MMCdyCode key={index} />
          }else{
            return <li className={"issueBox" + index} key={index}><span className = "issueBox">{item}</span></li>
          }
        }
        break;
        case "pl3":{
          return <li key = {index}><span className = "issueBox">{item}</span></li>;  
        }
        break;
        case "jsk3":
        case "hnks":
        case "jlks":{
          return <li key = {index}  className={"issueBox" + index}><span className = {"issueBox" + index + " num_" + item}></span></li>;
        }
        break;
        default:{
          return <li className={"issueBox" + index} key = {index}><span className = "issueBox">{item || '-'}</span></li>
          ;
        }
      }

    })
  }

  // 秒秒彩模拟开奖
  simulatedNumber(){
    const __methods = this.props.__METHOD.toJS();
    if (__methods.windows[this.props.windowId].simulating) {return;}
    if (__methods.windows[this.props.windowId].error) {return;}
    this.props.$$LOTTERY.toggleSimulatStatus(this.props.windowId, true);
    this.props.$$LOTTERY.simulatedNumber(23, this.props.windowId);
  }

  // 重新请求信的奖期
  requestNewIssue(isNew){
    const __methods = this.props.__METHOD.toJS();
    const __window = this.props.__METHOD.toJS().windows[this.props.windowId];
    if (__window.error) {return;}
    // 新奖期则提示进入下一个奖期
    if (isNew) {
      // 先关闭确认框
      // 可追期数
      const track_limit = __window.current_issue.current.track_limit;
      const currentTrackIssue = JSON.parse(__window.track_issue).length;
      let requestNewTrackInfo = currentTrackIssue <= track_limit ? true : false;
      this.props.$$LOTTERY.nextCurrentIssue(this.props.windowId, __window.id, __window.flag, requestNewTrackInfo, track_limit)
      this.props.$$BASE.closeConfirm();
      // this.props.$$BASE.openToast('当期销售已截止，请进入下一期购买。');
      this.props.$$BASE.openAlert('当期销售已截止，请进入下一期购买。', null, 3);
      this.props.$$LOTTERY.resetTrackInfo(this.props.windowId);
    }
  }

  changeBalanceDisplay(){
    const __base =  this.props.__BASE.toJS();
    if (__base.config.showBalance) {
      this.props.$$BASE.hideBalance();
    }else{
      this.props.$$BASE.showBalance();
    }
  }

  //瑞典2分彩小箭头悬停
  openDropdown(){
    clearTimeout(this.closeTimer)
    ReactDOM.findDOMNode( this.refs.rd2ffc ).style.display = "block"
  }

  //瑞典2分彩小箭头移开
  closeDropdown(){
    clearTimeout(this.closeTimer)
    this.closeTimer = setTimeout(()=>{
      ReactDOM.findDOMNode( this.refs.rd2ffc ).style.display = "none"
    },500)
  }
  //瑞典2分彩
  numSj(){
    const __methods = this.props.__METHOD.toJS();
    if (__methods.windows[this.props.windowId] == null ) {
      return;
    }
    if (_.isEmpty(__methods.windows[this.props.windowId].current_issue)) {
      return;
    }
    if (!__methods.windows[this.props.windowId].current_issue.current) {
      return;
    }
    if (!__methods.windows[this.props.windowId].current_issue.history) {
      return;
    }
    if (this.props.params.lotteryFlag != "rd2fc") {
      return;
    }
    //最后一位加红数字
    this.last_code = _.chain(__methods.windows[this.props.windowId].current_issue.history.original_code).split(' ').map((item) => parseInt(item)).chunk(4).map((item) => _.sum(item) % 10).join('').value();
    this.lastCode = []
    this.last_code.split('').map((item)=>{
      this.lastCode.push(item)
    })
    this.detail_code = _.chain(__methods.windows[this.props.windowId].current_issue.history.original_code).split(' ').chunk(4).value();
    if(!this.detail_code[0][0]||!this.detail_code[1][0]||!this.detail_code[2][0]||!this.detail_code[3][0]||!this.detail_code[4][0]){
      return
    }
    //万位
    let one = Number(this.detail_code[0][0])+Number(this.detail_code[0][1])+Number(this.detail_code[0][2])+Number(this.detail_code[0][3])
    this.firstCode = one+""
    if(one > 100){
      this.million = this.firstCode[0]+this.firstCode[1]
    }else{
      this.million = this.firstCode[0]
    }
    //千位
    let two = Number(this.detail_code[1][0])+Number(this.detail_code[1][1])+Number(this.detail_code[1][2])+Number(this.detail_code[1][3])
    this.secCode = two+""
    if(two > 100){
      this.thousands = this.secCode[0]+this.secCode[1]
    }else{
      this.thousands = this.secCode[0]
    }
    //百位
    let three = Number(this.detail_code[2][0])+Number(this.detail_code[2][1])+Number(this.detail_code[2][2])+Number(this.detail_code[2][3])
    this.thirdCode = three+""
    if(three > 100){
      this.hundreds = this.thirdCode[0]+this.thirdCode[1]
    }else{
      this.hundreds = this.thirdCode[0]
    }
    //十位
    let four = Number(this.detail_code[3][0])+Number(this.detail_code[3][1])+Number(this.detail_code[3][2])+Number(this.detail_code[3][3])
    this.fouthCode = four+""
    if(four > 100){
      this.ten = this.fouthCode[0]+this.fouthCode[1]
    }else{
      this.ten = this.fouthCode[0]
    }
    //个位
    let five = Number(this.detail_code[4][0])+Number(this.detail_code[4][1])+Number(this.detail_code[4][2])+Number(this.detail_code[4][3])
    this.fiveCode = five+""
    if(five > 100){
      this.bit = this.fiveCode[0]+this.fiveCode[1]
    }else{
      this.bit = this.fiveCode[0]
    }
    //数字相加字符串
    this.codeList = []
    this.detail_code.map((item,index)=>{
      this.code = item.join('+')
      this.codeList.push(this.code)
    })

    return <span className="lottery_num_sj" onMouseOut = {this.closeDropdown} onMouseOver = {this.openDropdown} style={{"display": "inline"}}>详情</span>  
    
  }
  //收藏彩票
  addCurrentFavorites(){
    const __common = this.props.__COMMON.toJS();
    const __window = this.props.__METHOD.toJS().windows[this.props.windowId];
    if (_.chain(__common.favorites.lottery).map('target_id').includes(__window.id).value()) {
      return;
    }
    if (this.props.__COMMON.toJS().favorites.lottery.length >= 10) {
      return this.props.$$BASE.openToast('最多只能收藏10个彩种哦');
    }
    this.props.$$COMMON.createFavorites('lottery', {collection: [{target_id: __window.id}]})
  }
  //显示中奖号码
  showBall(){
    const __methods = this.props.__METHOD.toJS();
    if(__methods.windows == null||__methods.windows[this.props.windowId] == null ||__methods.windows[this.props.windowId].current_issue == null){
      return false
    }else{
      return this.historyCode
    }
  }
  render() {
    const __user = this.props.__USER.toJS();
    const __base = this.props.__BASE.toJS();
    const __common = this.props.__COMMON.toJS();
    const __window = this.props.__METHOD.toJS().windows[this.props.windowId];
    const { current_issue} = __window;
    const lotteryId = __window.id;
    let historyCodes
    if(current_issue.history){
      historyCodes = _.join(current_issue.history.split_code, '_')
    }
    let className = this.props.params.lotteryFlag+"_ul";
    if(this.props.params.lotteryFlag == "jssm"){
      className = "horse_ul"
    }
    if (!this.props.params) {return (<div className='lottery_head relative'><Loader /></div>)}
    return (
      <div className='lottery_head'>
      {
        this.props.params.lotteryFlag == "mmc"?
          <MMCHeader 
            showBallFn={this.showBall} 
            simulatedFn={this.simulatedNumber}
            addFavor={this.addCurrentFavorites}
            simulatStatus={__window.simulating}
            error={__window.error} 
            __window={__window}
            __COMMON={__common}
            $$COMMON={this.props.$$COMMON}
            $$BASE={this.props.$$BASE}
            windowId={this.props.windowId}
            lottery={this.props.$$LOTTERY}
            handleToggleSound={this.handleToggleSound}
            soundNotice={__base.config.soundNotice}
            />
          :
            <div className='clear'>
              <div className="lottery_type fl inline">
                <div className={'logo ' + this.props.params.lotteryFlag}></div>
              </div>
              <div className='fl'>
                <div className='clear'>
                    <p onClick={this.handleWinnerNotice} className={__base.config.winnerNotice ? 'winningReminder check' : 'winningReminder uncheck'}>中奖提醒</p>
                    <span
                        className={__base.config.soundNotice ? 'soundBtn soundClickEvent soundon' : 'soundBtn soundClickEvent soundoff'}
                        onClick={this.handleToggleSound}>
                    </span>
                </div>
                <div className="lottery_history_issue">
                  <span>第</span>
                  <b>{this.historyIssue}</b>
                  <span>期</span>
                </div>
              </div>
                <div className={"lottery_num fl inline lottery" + this.props.params.lotteryFlag}>
                    <ReactCSSTransitionGroup
                        transitionAppear={true}
                        transitionEnterTimeout={100}
                        transitionLeaveTimeout={100}
                        transitionAppearTimeout ={100}
                        transitionName='history-codes'
                        component='div'
                        className={'lottery_num_box alias-' + this.props.params.lotteryFlag}>
                        <ul id="num" key={this.props.params.lotteryFlag + historyCodes} className={className}>
                            {this.showBall()}
                        </ul>
                        {this.numSj()}
                    </ReactCSSTransitionGroup>
                    <div className="rd2ffc" ref = "rd2ffc" onMouseOut = {this.closeDropdown} onMouseOver = {this.openDropdown}>
                        <div className="lottery_num_popup">
                            {/*<span className="popup_icon_sj"></span>*/}
                            <ul id="rd2_list">
                                <li className="num_popup_item"><span className="num_popup_item_text">万位：</span><div className="num_popup_item_kjnum">{this.codeList[0]} = <span>{this.million}<em>{this.lastCode[0]}</em></span></div></li>
                                <li className="num_popup_item"><span className="num_popup_item_text">千位：</span><div className="num_popup_item_kjnum">{this.codeList[1]} = <span>{this.thousands}<em>{this.lastCode[1]}</em></span></div></li>
                                <li className="num_popup_item"><span className="num_popup_item_text">百位：</span><div className="num_popup_item_kjnum">{this.codeList[2]} = <span>{this.hundreds}<em>{this.lastCode[2]}</em></span></div></li>
                                <li className="num_popup_item"><span className="num_popup_item_text">十位：</span><div className="num_popup_item_kjnum">{this.codeList[3]} = <span>{this.ten}<em>{this.lastCode[3]}</em></span></div></li>
                                <li className="num_popup_item"><span className="num_popup_item_text">个位：</span><div className="num_popup_item_kjnum">{this.codeList[4]} = <span>{this.bit}<em>{this.lastCode[4]}</em></span></div></li>
                            </ul>
                        </div>
                    </div>
                </div>

              <div className="lottery-timeBox">
                <div className="lottery-history-box fl">
                  <p className="lottery-current">
                      当前在售&nbsp;:&nbsp;
                      <b className={__base.sound.play?"shake":""}>{
                        this.currentIssue && !this.error ? this.currentIssue : '00000000-000'}
                       </b>
                      &nbsp;期
                  </p>
                  {/*<p className={(__common.favorites.lottery && !_.chain(__common.favorites.lottery).map('target_id').includes(__window.id).value()) ? 'collecting' : 'collected'} onClick={() => this.addCurrentFavorites()}>*/}
                    {/*<span className={(__common.favorites.lottery && !_.chain(__common.favorites.lottery).map('target_id').includes(__window.id).value()) ? 'check' : ''}></span>*/}
                    {/*{(__common.favorites.lottery && !_.chain(__common.favorites.lottery).map('target_id').includes(__window.id).value()) ? '收藏' : '已收藏'}*/}
                  {/*</p>*/}
                  {/*<p className="betTime">*/}
                    {/*投注时间*/}

                  {/*</p>*/}
                </div>
                <TimeBox
                  request={this.requestNewIssue}
                  current={!this.error ? this.countdown : null}
                  interval={!this.error ? this.interval : null}
                  soundFn={this.props.$$BASE.countDown}
                  stopSoundFn={this.props.$$BASE.closeSound}
                  soundPlay={__base.sound.play} />
              </div>
            </div>
        }
      </div>
    );
  }
}

reactMixin(SscHeader.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __LOTTERY: state.lottery,
    __USER: state.user,
    __METHOD:state.method,
    __BASE: state.base,
    __COMMON: state.common
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SscHeader)



/**
 * 秒秒彩HEADER
 */
class MMCHeader extends React.Component{

  constructor(props) {
    super(props);
    this.toggleStopWhenWin = this.toggleStopWhenWin.bind(this);
  }

   // 切换是否中奖后停止
  toggleStopWhenWin(){
    const { windowId } = this.props;
    const status = this.props.__window.stopWhenWin;
    this.props.lottery.toggleStopWhenWin(windowId, !status)
  }

  // // 变更连续开奖期数
  // handleChangePlayTimes(number){
  //   const { windowId } = this.props;
  //   this.props.$$LOTTERY.mmcPlayTimes(windowId, number);
  // }
  addFavor(){
    const __common = this.props.__COMMON;
    const __window = this.props.__window;
    if (_.chain(__common.favorites.lottery).map('target_id').includes(__window.id).value()) {
      return;
    }
    if (__common.favorites.lottery.length >= 10) {
      return this.props.$$BASE.openToast('最多只能收藏10个彩种哦');
    }
    this.props.$$COMMON.createFavorites('lottery', {collection: [{target_id: __window.id}]})
  }
  render(){
    const {__window,__COMMON}= this.props;
    return (
      <div className="lottery_show lottery_mmc_show left">
        <div className="lottery_mmc">
          <div className="mmc_lottery_type">
            <div className="icon_xc_mmc"></div>
            <div className="clear fr mt15">
              <p onClick={() => this.toggleStopWhenWin()} className={this.props.__window.stopWhenWin ? 'winningReminder check' : 'winningReminder uncheck'}>中奖停止</p>
              <span className={this.props.soundNotice ? 'soundBtn soundClickEvent soundon' : 'soundBtn soundClickEvent soundoff'} onClick={this.props.handleToggleSound}></span>
            </div>
          </div>
          <div className="lottery_num fl inline">
              <div className="lottery_num_box">
                  <ul id="num">
                    {this.props.showBallFn()}
                  </ul>
              </div>
          </div> 
          <div className={this.props.simulatStatus || this.props.error ? "btn_open-award bet-enabled btn_open-award_disabled" : 'btn_open-award bet-enabled'}>
            <button onClick={this.props.simulatedFn}></button>
          </div>
        </div>
      </div>
    )
  }
}

/**
 * 秒秒彩动态号码圆圈
 */
class MMCdyCode extends React.Component{

  constructor(props) {
    super(props);
    this.pos = 0;
    this.code = 0;
  }

  componentDidMount(){
    this.posTimer = window.setInterval(function(){
      this.pos == 55 ? this.pos = -55 : this.pos ++
      this.code = _.random(9);
      // ReactDOM.findDOMNode( this.refs.randomCode ).style.top = this.pos + 'px';
      ReactDOM.findDOMNode( this.refs.randomCode ).innerHTML = this.code;
    }.bind(this), 50)
  }

  componentWillUnmount(){
    window.clearInterval(this.posTimer)
  }

  render(){
    return(
      <li style={{top: '0px'}}>
        <span ref='randomCode'></span>
      </li>
    )
  }

}